import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Form, Icon, InputNumber, Input, Progress, Select, Upload, Checkbox, Tooltip, Radio } from 'antd'
import { infoRequired, validateAgencia, validateNumeroBanco, validateCaracteresUpload, validateAcceptedFormat, validateFileSize } from '../../../utils/validators'
import { gerarContrato } from '../../../redux-flow/actions/contratos'
import { maskAgenciaOnChange, maskContaOnChange } from '../../../utils/masks';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import attach from '../../../images/attach.png'
import { planos } from '../../../constants'

import bancos from './bancos.js'

const Option = Select.Option
const { Dragger}  = Upload

class FormContrato extends PureComponent {
    constructor(props) {
        super(props)
        const planIds = Object.keys(planos)
        const firstPlanId = parseInt(planIds[0])
        const firstPlan = planos[firstPlanId]
        
        this.state = {
            qtdMes: firstPlanId === 17 ? 6 : 12,
            selectInitialValue: firstPlanId,
            rentabilidade: firstPlan.rentabilidade,
            file: null,
            cdBanco: 0,
            isValid: false,
            paymentMethod: 'bank_transfer'
        }
    }

    handlePaymentMethodChange = (e) => {
        this.setState({
            paymentMethod: e.target.value,
            file: e.target.value === 'bank_transfer' ? this.state.file : null
        })
    }

    beforeUpload = file => {
        // Verificar se é um objeto File válido
        console.log('File object no beforeUpload:', file);
        console.log('File type:', file.type);
        console.log('File name:', file.name);
        console.log('File size:', file.size);
        
        this.setState({
            file
        })
        return false
    }

    handleSelectChange = value => {
        const qtdMes = value === 17 ? 6 : 12
        const rentabilidade = planos[value].rentabilidade
        const investimento = planos[value].investimento * 100

        // Check if balance is sufficient when using balance payment
        if (this.state.paymentMethod === 'balance' && this.props.balance < investimento) {
            this.setState({ isValid: true })
        } else {
            this.setState({ isValid: false })
        }

        this.props.form.setFieldsValue({
            meses: qtdMes,
            investimento: investimento
        })
        this.setState({
            qtdMes: qtdMes,
            selectInitialValue: value,
            rentabilidade
        })
        this.props.handleChange(value)
    }

    selectBank = (event) => {
        //console.log(event.target.value)
    }

    handleMesesChange = value => {
        const rentabilidade = planos[this.state.selectInitialValue].meses[value]
        this.setState({
            qtdMes: value,
            rentabilidade
        })
    }

    currencyFormatter = (e) => {
        var tmp = e+'';
        tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
        if( tmp.length > 6 )
                tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");

        return tmp;
    }

    render() {
        const { form, handleSubmit, logMessage, isLoading, success, userid, balance } = this.props
        const { selectInitialValue, paymentMethod } = this.state
        const investimento = planos[selectInitialValue].investimento * 100

        return success ? (
            <div className="animated bounceInRight finishedSignup">
                <div>
                    <h2 className='final-header'>Contrato Requisitado!</h2>
                    <p className='fianl-text-paragraph'>
                        Sucesso! Seu contrato foi requisitado e está sendo processado! <br />
                        Assim que estiver pronto, entraremos em contato e disponibilizaremos o link para download. Você já pode voltar para a sua <Link to="/minhaconta">página de conta</Link>.
                    </p>
                </div>
                <div className="mt-5">
                    <Link to="/meusinvestimentos">
                        <button className="btnSubmit"> ← Voltar para meus investimentos</button>
                    </Link>
                </div>
            </div>
        ) : (
            <Form layout="vertical" className="formContrato" onSubmit={handleSubmit(form, this.state.file, userid, this.state.qtdMes, paymentMethod)}>
                {logMessage && <Form.Item>
                    <div className="alert alert-danger fade show notificacao-status">
                        <p className="mb-0">{logMessage}</p>
                    </div>
                </Form.Item>}

                <div style={{ textAlign: 'center' }}>
                    {isLoading && <Form.Item>
                        <Icon type="loading" />
                    </Form.Item>}
                </div>

                <Row>
                    <Col md={12}>
                        <Form.Item label="Método de Pagamento">
                            <Radio.Group onChange={this.handlePaymentMethodChange} value={paymentMethod}>
                                <Radio value="bank_transfer">Transferência Bancária</Radio>
                                <Radio value="balance">Saldo Disponível</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    {paymentMethod === 'balance' && (
                        <Col md={12}>
                            <div className="alert alert-info">
                                <p className="mb-0">
                                    Saldo disponível: R$ {balance ? (balance/100).toFixed(2) : '0,00'}
                                    {balance < investimento && (
                                        <span className="text-danger ml-2">
                                            (Saldo insuficiente para solicitar este contrato)
                                        </span>
                                    )}
                                </p>
                            </div>
                        </Col>
                    )}
                    <Col md={6}>
                        <Form.Item 
                        label={'Planos'}
                        >
                            {form.getFieldDecorator('produto', {
                                initialValue: selectInitialValue,
                                rules: [ infoRequired ]
                            })(
                                <Select onChange={this.handleSelectChange}>
                                    {Object.keys(planos)
                                        .map(key => (
                                            <Option key={key} value={parseInt(key)}>
                                                {planos[key].nome}
                                            </Option>
                                        ))
                                    }
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col md={6}>
                        <Form.Item label="Valor do depósito">
                            {form.getFieldDecorator('investimento', {
                                initialValue: investimento,
                                rules: [ infoRequired ]
                            })(
                                <InputNumber
                                    formatter={value => this.currencyFormatter(value)}
                                    max={100000000}
                                    min={investimento}
                                    parser={value => String(value).replace(/\D/g, '')}
                                    style={{ width: '100%' }}
                                />
                            )}
                        </Form.Item>
                    </Col>
                    
                    {paymentMethod === 'bank_transfer' && (
                        <>
                            <Col md={12}>
                                <Form.Item label="Banco e código">
                                    {form.getFieldDecorator('codigoBanco', {
                                        rules: [ infoRequired ]
                                    })(
                                        <Select
                                            showSearch
                                        >
                                            {bancos.map(banco =>(
                                                <Option value={banco.name}>{banco.name}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col md={6}>
                                <Form.Item label="Agência Bancária (sem dígito)">
                                    {form.getFieldDecorator('agencia', {
                                        rules: [ infoRequired, validateAgencia() ]
                                    })(
                                        <Input
                                            style={{ width: '100%' }}
                                            placeholder="0000"
                                            onKeyPress={maskAgenciaOnChange}
                                            onChange={maskAgenciaOnChange}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col md={6}>
                                <Form.Item label="Número da Conta (com dígito)">
                                    {form.getFieldDecorator('conta', {
                                        rules: [ infoRequired, validateNumeroBanco() ]
                                    })(
                                        <Input
                                            style={{ width: '100%' }}
                                            placeholder="00000-0"
                                            onKeyPress={maskContaOnChange}
                                            onChange={maskContaOnChange}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col md={12}>
                                <h6 className="subTitle tx-pink">Comprovante de Depósito</h6>
                                <p className="tx-darker"><FontAwesomeIcon className="mr-2" icon={faInfoCircle}></FontAwesomeIcon>Por favor, envie seu comprovante de depósito. O nome do arquivo deve conter até 15 caractéres.</p>
                                <Form.Item>
                                    {form.getFieldDecorator('upload', {
                                        rules: [ infoRequired, validateCaracteresUpload(), validateAcceptedFormat(), validateFileSize() ]
                                    })(
                                        <Dragger 
                                            beforeUpload={this.beforeUpload} 
                                            onRemove={() => this.setState({ file: null })}
                                            multiple={false}
                                        >
                                            <label className="tx-pink mb-0"><img alt="Ícone de upload" src={attach} className="img-fluid" />Clique ou arraste e solte o arquivo aqui</label>
                                        </Dragger>
                                    )}
                                </Form.Item>
                            </Col>
                        </>
                    )}
                    <Col md={12}>
                        <Form.Item>
                            {form.getFieldDecorator('checkbox', {
                                rules: [ infoRequired ]
                            })(
                                <Checkbox>Li e concordo com a <a href="https://up365capital.com.br/politica.html" target="_blank" className="tx-pink"><u>Política de Privacidade</u></a></Checkbox>
                            )}
                        </Form.Item>
                        {/* Campo oculto para método de pagamento */}
                        {form.getFieldDecorator('paymentMethod', {
                            initialValue: paymentMethod
                        })(<Input type="hidden" />)}
                    </Col>
                    <Col md={12}>
                        <Form.Item>
                            <button 
                                type="submit" 
                                className="btnGrafico" 
                                disabled={this.state.isValid || (paymentMethod === 'balance' && balance < investimento)}
                            >
                                Confirmar
                            </button>
                        </Form.Item>
                    </Col>
                </Row>         
            </Form>
        )
    }
}

const mapStateToProps = state => ({
    logMessage: state.contratos.message,
    isLoading: state.contratos.isLoading,
    success: state.contratos.success,
    userid: state.login.userid,
    balance: state.wallet.balance
})

const mapDispatchToProps = dispatch => ({
    handleSubmit: (form, comprovante, userid, qtMes, paymentMethod) => e => {
        e.preventDefault()
        window.scrollTo(0, 190)
        if (paymentMethod === 'bank_transfer') {
            console.log('Arquivo a ser enviado:', comprovante);
            dispatch(gerarContrato(form, comprovante, userid, qtMes, paymentMethod))
        } else {
            dispatch(gerarContrato(form, null, userid, qtMes, paymentMethod))
        }
    }
})

export default Form.create({ name: 'create-contrato' })(
    connect(mapStateToProps, mapDispatchToProps)(FormContrato)
)